import styled from 'styled-components';

export const DescriptionSubtitle = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black6};
`;

export const TagName = styled.p`
  overflow: hidden;
  margin: 0;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const TagList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const CourseName = styled.span`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const SectionName = styled(TagName)`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const TagListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CourseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
